/*eslint-disable*/
import format from 'timestamp-format';
//邮箱星号
function hideEmailMiddle(email) {
  // 查找 @ 符号的位置
  const atIndex = email.indexOf('@');

  // 如果邮箱不合法（没有 @ 符号），则返回原邮箱
  if (atIndex === -1) {
      return email;
  }

  // 确定需要隐藏的字符数（最多三个，但不超过 @ 前的字符数）
  const hideCount = 3;
  const preAtLength = atIndex; // @ 符号前的字符数
  const actualHideCount = Math.min(hideCount, preAtLength);

  // 构建隐藏后的字符串（用 * 替换需要隐藏的字符）
  // 注意这里我们是从字符串开始处到 atIndex - actualHideCount 位置取子串
  // 然后再加上三个 * 和 @ 符号及其后的部分
  const visiblePartBeforeHide = preAtLength > actualHideCount ? email.slice(0, atIndex - actualHideCount) : '';
  const hiddenPart = '*'.repeat(actualHideCount);
  const postAtPart = email.slice(atIndex);

  // 拼接结果
  const hiddenEmail = visiblePartBeforeHide + hiddenPart + postAtPart;

  return hiddenEmail;
}

// 获取提现方式名称
function getWithdrawType(type) {
  if (type == 0) {
    return "银行卡";
  } else if (type == 1) {
    return "USDT";
  } else if (type == 2) {
    return "支付宝";
  } else if (type == 3) {
    return "VIPPAY";
  } else if (type == 4) {
    return "GOPAY";
  } else if (type == 5) {
    return "EBPAY";
  } else if (type == 6) {
    return "YBFPAY";
  } else if (type == 7) {
    return "KDPay";
  } else if (type == 8) {
    return "CBPAY";
  } else if (type == 9) {
    return "OKPAY";
  } else if (type == 10) {
    return "JDPAY";
  } else if (type == 11) {
    return "BCPAY";
  } else if (type == 12) {
    return "PayMaya";
  } else if (type == 13) {
    return "GrabPay";
  }
}
//获取N个月前的今天到现在有多少天
function getDaysFromNMonthsAgoToToday(n) {
  const today = new Date(); // 获取今天的日期
  const todayDate = today.getDate(); // 获取今天的日期号

  // 计算 n 个月前的日期
  const pastDate = new Date(today);
  pastDate.setMonth(today.getMonth() - n);
  
  // 将过去日期设置为 n 个月前的“今天”日期
  pastDate.setDate(todayDate);

  // 计算日期差异
  const timeDifference = today - pastDate; // 时间差，单位是毫秒
  const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // 转换为天数

  return dayDifference;
}
// 阿拉伯数字转汉字
function SectionToChinese(section){
  var chnNumChar = ["零","一","二","三","四","五","六","七","八","九"];
  var chnUnitChar = ["","十","百","千","万","亿","万亿","亿亿"];
  var strIns = '', chnStr = '';
  var unitPos = 0;
  var zero = true;
  var section=Number(section);
  while(section > 0){
      var v = section % 10;
      if(v === 0){
           if(!zero){
                zero = true;
                chnStr = chnNumChar[v] + chnStr;
           }
      }else{
            zero = false;
            strIns = chnNumChar[v];
            strIns += chnUnitChar[unitPos];
            chnStr = strIns + chnStr;
      }
      unitPos++;
      section = Math.floor(section / 10);
   }
   return chnStr;
}
function userName(name) {
  name=name.toString();
  return name.slice(0,3) + '***' + name.slice(-2);
  // return name.slice(0,3) + new Array(name.length-4).join('*') + name.slice(-2);
}

function toName(name) {
  name=name+'';
  return new Array(name.length).join('*') + name.substr(-1);
}

function idNumber(name) {
  if(!name){
    return ''
  }
  name = name+'';
  return name.substr(0, 3) + ' ***** ***** ***** ' + name.substr(16, 18)
}
function birthdayNumber(num) {
  if(!num){
    return ''
  }
  let start,mid,end;
  num = num.toString();
  num = num.slice(6,14);
  start = num.slice(0,4);
  mid = num.slice(4,6);
  end = num.slice(6,8);
  num = start+'年'+mid+'月'+end + '日';
  return num
}
function formatPhone(phone) {
  phone = phone+'';
  return phone.substr(0, 3) + ' **** ' + phone.substr(7, 11);
}
function bankNumber(num) {
  num = num+'';
  if(num.length===19){
    return ' **** **** **** **** ' + num.substr(16, 19);
  }else if(num.length===18){
    return ' **** **** **** ' + num.substr(12, 18);
  }else if(num.length===16){
    return ' **** **** **** ' + num.substr(12, 16);
  }else if(num.length===17){
    return ' **** **** **** ' + num.substr(12, 17);
  }
}
function emailNum(num){
  return num>99?'+99':num
}
// 提现申请的状态
function withdrawalStatus(type) {
  let S = "";
  switch (type) {
    case "0":
      return "申请中";
    case "1":
      return "出款中";
    case "2":
      return "成功";
    case "3":
      return "拒绝";
    case "4":
      return "出款中";
    case "5":
      return "出款中";
    default:
  }
  return S;
}
// 提现申请的状态
function depositStatus(type) {
  let S = "";
  switch (type) {
    case "0":
      return "锁定中";
    case "1":
      return "成功";
    case "2":
      return "失败";
    case "3":
      return "已取消";
    case "4":
      return "已冻结";
    default:
  }
  return S;
}
function gameName(type) {
  let S = "";
  switch (type) {
    case "1":
      return "老虎机";
    case "2":
      return "真人";
    case "3":
      return "体育";
    case "4":
      return "彩票";
    case "5":
      return "捕鱼王";
    case "6":
      return "棋牌";
    case "7":
      return "3D厅";

    default:
  }
  return S;
}
function gameNameJ2(type) {
  let S = "";
  switch (type) {
    case "1":
      return "电子";
    case "2":
      return "真人";
    case "3":
      return "体育";
    case "4":
      return "彩票";
    case "5":
      return "捕鱼";
    case "6":
      return "棋牌";
    case "7":
      return "3D厅";

    default:
  }
  return S;
}
function changeTitle(val) {
  if(val==='0'){
    return '申请中'
  }else if(val==='1'){
    return '系统调帐'
  }else if(val==='2'){
    return '充值存款'
  }else if(val==='3'){
    return '秒速取款'
  }else if(val==='4'){
    return '转入游戏'
  }else if(val==='5'){
    return '游戏转出'
  }else if(val==='8'){
    return '优惠红利'
  }else if(val==='9'){
    return '人工存入'
  }else if(val==='10'){
    return '人工取出'
  }
}
function changeTitleJ2(val) {
  if(val==='0'){
    return '申请中'
  }else if(val==='1'){
    return '调账'
  }else if(val==='2'){
    return '存款'
  }else if(val==='3'){
    return '提款'
  }else if(val==='4'){
    return '转入游戏'
  }else if(val==='5'){
    return '游戏转出'
  }else if(val==='8'){
    return '优惠'
  }else if(val==='9'){
    return '人工存款'
  }else if(val==='10'){
    return '人工提款'
  }
}

function getTimeMS(time) {
  return format('yyyy-MM-dd hh:mm:ss',time)
}
function getTimeYDMS(time) {
  return format('yyyy/MM/dd hh:mm:ss',time)
}
function getTimeYMDS(time) {
  return format('yyyy年MM月dd日 hh:mm:ss',time)
}
function getTimeMD(time) {
  return format('yyyy-MM-dd ',time)
}
function getTimeMDSlash(time) {
  return format('yyyy/MM/dd ',time)
}
// 体育日期
function getTimeYMDSports(time) {
  time = time.split('(')[1];
  time = time.split(')')[0];
  time = parseInt(time)
  return format('yyyy/MM/dd ',time)
}
function getTimeYMD(time) {
  return format('yyyy年MM月dd日 hh:mm',time)
}
function bonusTypes(type) {
  if(type==='0'){
    return '前置红利'
  }else if(type==='1'){
    return '后置红利'
  }else if(type==='2'){
    return '减去红利'
  }
}
// 红利类型
function bonusName(type) {
  let type1 = '';
  switch (type) {
    case "1":
      type1 = "返水红利";
      return type1;
    case "2":
      type1 = "存款优惠";
      return type1;
    case "3":
      type1 = "邀请奖励";
      return type1;
    case "4":
      type1 = "签到奖励";
      return type1;
    case "6":
      type1 = "连续存款优惠";
    case "7":
      type1 = "注册优惠";
      return type1;
    case "A":
      type1 = "救援金";
      return type1;
    case "B":
      type1 = "VIP升级奖励";
      return type1;
    case "C":
      type1 = "VIP蝉联奖励";
      return type1;
    default:
      type1 = "其他优惠";
      return type1;
  }
}
// 红利锁定状态
function bonusLockStatus(status) {
  let type1 = '';
  switch (status) {
    case "1":
      type1 = "锁定中";
      return type1;
    case "2":
      type1 = "已解锁";
      return type1;
    case "4":
      type1 = "已取消";
      return type1;

    default:
      type1 = "锁定中";
      return type1;
  }
}
// 红利锁定平台
function bonusLockPlatform(platform) {
  let type1 = '';
  switch (platform) {
    case "-1":
      type1 = "主账户";
      return type1;
    default:
      type1 = platform;
      return type1;
  }
}
// 存款锁定状态
function depositLockStatus(status) {
  let type1 = '';
  switch (status) {
    case "0":
      type1 = "锁定中";
      return type1;
    case "1":
      type1 = "已解锁";
      return type1;
    default:
      type1 = "锁定中";
      return type1;
  }
}


// 红利状态
function changeName(val) {
  // filterType:状态 -1=全部 0:申请中，1:进行中，2:成功发放，3:拒绝，4:失败，5未领取，6未抽中
  // filterType:状态 -1=全部 0:申请中，1:成功领取，2:完成流水，3:拒绝，4:清除稽核，5未领取，6未抽中
  if(val==='0'){
    return '申请中'
  }else if(val==='1'){
    return '成功领取'
  }else if(val==='2'){
    return '完成流水'
  }else if(val==='3'){
    return '拒绝'
  }else if(val==='4'){
    return '清除稽核'
  }else if(val==='5'){
    return '未领取'
  }else if(val==='6'){
    return '未抽中'
  }
}
function invitationStatus(type) {
  if(type==='0'){
    return '未注册'
  }else if(type==='1'){
    return '已注册'
  }else if(type==='2'){
    return '已过期'
  }
}
// 金额格式化
function formatCurrency(num) {
  num = num.toString().replace(/\$|\,/g,'');
  if(isNaN(num))
    num = "0";
  let sign = (num == (num = Math.abs(num)));
  num = Math.floor(num*100+0.50000000001);
  let cents = num%100;
  num = Math.floor(num/100).toString();
  if(cents<10)
    cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
    num = num.substring(0,num.length-(4*i+3))+','+
      num.substring(num.length-(4*i+3));
  return (((sign)?'':'-') + num + '.' + cents);
}



export default {
  formatPhone: formatPhone,
  toName: toName,
  bankNumber: bankNumber,
  changeName: changeName,
  changeTitle: changeTitle,
  changeTitleJ2: changeTitleJ2,
  getTimeMS: getTimeMS,
  getTimeYDMS: getTimeYDMS,
  getTimeMD: getTimeMD,
  bonusTypes: bonusTypes,
  bonusLockStatus,
  bonusLockPlatform,
  depositLockStatus,
  bonusName: bonusName,
  invitationStatus: invitationStatus,
  idNumber: idNumber,
  getTimeMDSlash: getTimeMDSlash,
  getTimeYMD: getTimeYMD,
  getTimeYMDS: getTimeYMDS,
  withdrawalStatus: withdrawalStatus,
  gameName: gameName,
  gameNameJ2: gameNameJ2,
  userName: userName,
  SectionToChinese: SectionToChinese,
  getDaysFromNMonthsAgoToToday: getDaysFromNMonthsAgoToToday,
  getWithdrawType: getWithdrawType,
  hideEmailMiddle: hideEmailMiddle,
  formatCurrency: formatCurrency,
  birthdayNumber: birthdayNumber,
  depositStatus,
  getTimeYMDSports,
  emailNum,
}



// WEBPACK FOOTER //
// ./src/common/filter/infoFilter.js